// Keep this self-contained script as text. Babel's transform-runtime rewrites built-ins
// into module helpers, which are unavailable when a function.toString() runs remotely.
const installHeaderScript = `(function (title, closeLabel, expectedOrigin) {
  if (window.location.origin !== expectedOrigin || !document.body) return false
  var bridge = window.cordova_iab ||
    (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab)
  if (!bridge || typeof bridge.postMessage !== 'function') return false
  if (document.getElementById('mengo-trip-header')) return true

  var header = document.createElement('div')
  header.id = 'mengo-trip-header'
  header.setAttribute('role', 'banner')
  header.style.cssText = 'position:fixed!important;top:0!important;left:0!important;right:0!important;' +
    'z-index:2147483647!important;box-sizing:border-box!important;display:flex!important;' +
    'align-items:center!important;justify-content:space-between!important;background:#fff!important;' +
    'color:#333!important;padding:0 12px 0 20px!important;min-height:56px!important;' +
    'padding-top:env(safe-area-inset-top,0px)!important;border-bottom:1px solid #eee!important;' +
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;'
  var label = document.createElement('strong')
  label.textContent = title
  label.style.cssText = 'font-size:20px!important;font-weight:700!important;line-height:1.4!important;'
  var close = document.createElement('button')
  close.type = 'button'
  close.textContent = '×'
  close.setAttribute('aria-label', closeLabel)
  close.style.cssText = 'display:block!important;width:44px!important;height:56px!important;' +
    'padding:0!important;margin:0!important;border:0!important;border-radius:0!important;' +
    'background:transparent!important;box-shadow:none!important;color:#333!important;' +
    'font:32px/1 sans-serif!important;cursor:pointer!important;flex-shrink:0!important;'
  close.onclick = function () {
    bridge.postMessage(JSON.stringify({ type: 'mengo-trip-close' }))
  }
  header.appendChild(label)
  header.appendChild(close)
  document.body.appendChild(header)

  // Reserve space for the header; constrain common SPA roots so map controls stay visible.
  var root = document.querySelector('#app, #root, app-root')
  var originalPadding = parseFloat(window.getComputedStyle(document.body).paddingTop) || 0
  function resize () {
    var height = header.getBoundingClientRect().height
    document.body.style.setProperty('padding-top', (originalPadding + height) + 'px', 'important')
    document.body.style.setProperty('box-sizing', 'border-box', 'important')
    if (root) {
      root.style.setProperty('height', Math.max(0, window.innerHeight - height - originalPadding) + 'px', 'important')
      root.style.setProperty('min-height', '0', 'important')
      // Fixed-position children then use the remaining content area as their containing block.
      root.style.setProperty('transform', 'translateZ(0)', 'important')
    }
  }
  resize()
  window.addEventListener('resize', resize)
  return header.getBoundingClientRect().height > 0
})`

export function openTripPlanningBrowser (url, title, closeLabel, onExit, onError) {
  var browser = window.cordova.InAppBrowser.open(url, '_blank',
    'hidden=yes,location=no,toolbar=no,footer=no,hardwareback=no,fullscreen=no')
  var ended = false
  var timeout
  var generation = 0
  var expectedOrigin = new URL(url).origin
  function clearTimer () { clearTimeout(timeout) }
  function finish () {
    if (ended) return
    ended = true
    clearTimer()
    onExit()
  }
  function close () {
    if (ended) return
    finish()
    browser.close()
  }
  function fail () {
    if (ended) return
    close()
    onError()
  }
  function startLoading () {
    if (ended) return
    generation++
    browser.hide()
    clearTimer()
    timeout = setTimeout(fail, 30000)
  }
  browser.addEventListener('exit', finish)
  browser.addEventListener('loaderror', fail)
  browser.addEventListener('loadstart', startLoading)
  browser.addEventListener('message', function (event) {
    var data = event.data
    if (typeof data === 'string') {
      try { data = JSON.parse(data) } catch (error) { return }
    }
    if (data && data.type === 'mengo-trip-close') close()
  })
  browser.addEventListener('loadstop', function (event) {
    if (ended) return
    var currentGeneration = generation
    try {
      if (new URL(event.url).origin !== expectedOrigin) return fail()
      var code = installHeaderScript + '(' +
        [title, closeLabel, expectedOrigin].map(value => JSON.stringify(value)).join(',') + ');'
      browser.executeScript({ code }, function (result) {
        if (ended || currentGeneration !== generation) return
        if (!result || result[0] !== true) return fail()
        clearTimer()
        browser.show()
      })
    } catch (error) { fail() }
  })
  startLoading()
  return { close }
}



// WEBPACK FOOTER //
// ./src/utils/tripPlanningBrowser.js